import { IntlShape } from "react-intl";
import { IFormField } from "@cayo/shared/api/types/schema";
import messages from "./messages";

const notSetForm = (intl: IntlShape) => {
  return {
    title: intl.formatMessage(messages.notSet),
    items: [] as IFormField[],
  };
};

export default notSetForm;
